"use strict";

import axios from "@/plugins/axios";
import router from "../../router";
const FileDownload = require('js-file-download');

export const user = {
  namespaced: true,
  state: {
    user: {},
    users: [],
    trainers: [],
    requests: [],
    update: null,
    isLoggedIn: false
  },
  getters: {
    getLoggedIn: state => state.isLoggedIn,
    getUser: state => state.user,
    getUsers: state => {
      return state.users.sort(function (a, b) {
        return ('' + a.fullname).localeCompare(b.fullname);
      })
    },
    getTrainers: state => state.trainers,
    getUpdate: state => state.update,
    getRequests: state => state.requests,
  },
  mutations: {
    SET_USER: (state, payload) => {
      if (!payload) payload = {}
      window.localStorage.setItem("tgs_user", JSON.stringify(payload));
      state.user = payload;
    },
    SET_USERS: (state, payload) => {
      state.users = payload;
    },

    SET_REQUESTS: (state, payload) => {
      state.requests = payload;
    },
    SET_TRAINERS: (state, payload) => {
      state.trainers = payload;
    },
    SET_LOGGED_IN: (state, payload) => (state.isLoggedIn = payload)
  },
  actions: {
    async verifyAccount(_context, payload) {
      try {
        let res = (await axios.post("/api/verifyAccount", payload)).data;
        window.flash({ type: res.success ? "success" : "error", msg: res.message })
      } catch (e) {
        return e

      }
    },

    async update({ commit }, payload) {
      try {
        let res = (await axios.put("api/users", payload)).data;
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
        if (res.success) {
          commit("SET_USER", res.data);
          return true;
        }
      } catch (error) {
        return error;
      }
    },

    async toggleRole({ state }, payload) {
      try {
        let res = (await axios.post("/api/tooggelUserRole", payload)).data;
        if (res.success) {
          state.users.forEach((user, index) => {
            if (user._id === payload._id) {
              if (state.users[index].roles.includes(payload.role)) state.users[index].roles.splice(state.users[index].roles.indexOf(payload.role), 1)
              else state.users[index].roles.push(payload.role)
            }
          });
        }
        window.flash({ type: res.success ? "success" : "error", msg: res.message })
      } catch (e) {
        return e

      }
    },

    async rejectCourse({ state }, payload) {
      try {
        let res = (await axios.get(`api/course/reject/${payload}`)).data;
        if (res.success) {
          state.requests.splice(state.requests.indexOf(x => x._id === payload), 1)
        }
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        window.flash({
          type: "error",
          msg: error.message,
        });
      }
    },
    async publishCourse({ state }, payload) {
      try {
        let res = (await axios.get(`api/course/grant/${payload}`)).data;
        if (res.success) {
          state.requests.splice(state.requests.indexOf(x => x._id === payload), 1)
        }
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        window.flash({
          type: "error",
          msg: error.message,
        });
      }
    },
    async rejectWorkshop({ state }, payload) {
      try {
        let res = (await axios.get(`api/workshop/reject/${payload}`)).data;
        if (res.success) {
          state.requests.splice(state.requests.indexOf(x => x._id === payload), 1)
        }
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        window.flash({
          type: "error",
          msg: error.message,
        });
      }
    },
    async publishWorkshop({ state }, payload) {
      try {
        let res = (await axios.get(`api/workshop/grant/${payload}`)).data;
        if (res.success) {
          state.requests.splice(state.requests.indexOf(x => x._id === payload), 1)
        }
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        window.flash({
          type: "error",
          msg: error.message,
        });
      }
    },
    async deleteUser({ state }, payload) {
      try {
        let res = (await axios.delete(`/api/users/${payload}`)).data
        if (res.success) state.users.splice(state.users.findIndex(user => user._id === res.data._id), 1)
        window.flash({ type: res.success ? "success" : "error", msg: res.message })
      } catch (error) {
        return error;
      }
    },
    async blockUser({ state }, payload) {
      try {
        let res = (await axios.get(`/api/user/block/${payload}`)).data
        if (res.success) state.users.filter((user, index) => {
          if (user._id === payload) state.users[index].blocked = !state.users[index].blocked
        })
        window.flash({ type: res.success ? "success" : "error", msg: res.message })
      } catch (error) {
        return error;
      }
    },

    async setNewPassword(_context, paylaod) {
      try {
        let res = (await axios.post("/api/resetPassword", paylaod)).data;
        if (res.success) {
          setTimeout(() => {
            router.push({ name: "Login", params: { lang: "de" } });
          }, 3000);
        }
        window.flash({ type: res.success ? "success" : "error", msg: res.message })
      } catch (error) {
        return error;
      }
    },

    async resendToken(_context, payload) {
      try {
        let res = (await axios.get(`/api/resendToken/${payload}`)).data;
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        return false;
      }
    },

    async checkUserIsLoggedIn({ state, commit }) {

      if (!state.user.email) {

        let tgs_user = await JSON.parse(window.localStorage.getItem("tgs_user"));
        if (tgs_user && tgs_user.email) {
          commit("SET_USER", tgs_user);
          commit("SET_LOGGED_IN", true);
          return true;
        }

        return false;
      }

      return true;
    },
    async addUser({ dispatch }, payload) {
      try {
        let res = (await axios.post("/api/users", payload)).data;
        window.flash({ type: res.success ? "success" : "error", msg: res.message })
        if (!res.success) return res;
        if (payload.roles.includes('workshop')) {
          dispatch("workshop/getWorkshops", {}, { root: true });
        }
        if (payload.roles.includes('department')) {
          dispatch("department/getDepartments", {}, { root: true });
        }
        dispatch('getUsers');
        return true;
      } catch (error) {

        return error
      }
    },
    async getRequests({ commit }) {
      try {
        let res = (await axios.get('/api/publishrequests')).data;

        if (res.success) commit('SET_REQUESTS', res.data)
      } catch (error) {
        return error;
      }
    },
    async getTrainers({ commit }) {
      try {
        let res = (await axios.get("/api/trainers")).data
        if (res.success)
          commit("SET_TRAINERS", res.data);
      } catch (error) {

        return error
      }
    },

    async getUsers({ commit }) {
      try {
        let res = (await axios.get("/api/users")).data
        if (res.success)
          commit("SET_USERS", res.data);
      } catch (error) {
        return error
      }
    },

    async exists() {
      try {
        let localUser = JSON.parse(window.localStorage.getItem("tgs_user"));
        let res = (await axios.post("/api/exists", { _id: localUser._id })).data
        if (res.data.exists) {
          window.localStorage.setItem("tgs_user", JSON.stringify(res.data.user));
        }
        return res.data.exists;
      } catch (error) {
        return error
      }
    },

    async login({ commit }, payload) {
      let { email, password, recaptchaToken } = payload;
      try {
        let res = (await axios.post("/api/login", { email, password, recaptchaToken })).data;
        if (res.success) {
          commit("SET_USER", res.data.user);
          commit("SET_LOGGED_IN", true);
          window.localStorage.setItem("access_token", res.data.access_token);
          router.push({ name: "Dashboard", params: { lang: "de" } });
        }

        window.flash({ type: res.success ? "success" : "error", msg: res.message })
      } catch (e) {
        return e
      }
    },

    async fixEmails() {
      try {
        let res = (await axios.get("/api/users/fixEmails")).data;
        window.flash({ type: res.success ? "success" : "error", msg: res.message })
      } catch (error) {
        return error
      }
    },

    async getLastUpdatedBy({ state }) {
      try {
        let res = (await axios.get(`/api/lastUpdatedBy`)).data
        if (res.success) state.update = res.data;
      } catch (error) {
        return error;
      }
    },

    async getBackup() {
      try {
        return axios({
          method: 'get',
          url: '/api/backup',
          responseType: 'blob', // Important
        }).then(res => {
          let date = new Date();
          FileDownload(res.data, 'backup_' + date.getFullYear() + '_' + String(date.getMonth() + 1).padStart(2, '0') + '_' + String(date.getDate()).padStart(2, '0') + '.zip');
          window.flash({ type: "success", msg: "Backup erfolgrich heruntergeladen" })
          return Promise.resolve();
        }).catch(() => {
          window.flash({ type: "error", msg: "Es konnte kein Bachup erstellt werden" })
          return Promise.resolve()
        })
      } catch (error) {
        return error
      }
    },

    async forgotPassword(_context, payload) {
      let { email, recaptchaToken } = payload;
      try {
        let res = (await axios.post("/api/forgotPassword", { email, recaptchaToken })).data;
        if (res.success) {
          setTimeout(() => {
            router.push({ name: "Login", params: { lang: "de" } });
          }, 3000);
        }
        window.flash({ type: res.success ? "success" : "error", msg: res.message })
      } catch (e) {
        return e
      }
    },
    async verification({ commit }) {
      try {
        let res = (await axios.get("verification")).data;
        if (res.success) {

          commit("SET_USER", res.data);
          commit("SET_LOGGED_IN", true);
        }

      } catch (e) {

        return e
      }
    },
    async uploadImage({ state }, payload) {
      try {

        let res = (
          await axios.post("api/user/profileImage", payload, {
            headers: { "Content-Type": "multipart/form-data" },
          })
        ).data;

        if (res.success) state.user.photoURL = res.data.photoURL;
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        window.flash({
          type: "error",
          msg: error.message,
        });
      }

    },


    async logout({ commit }) {
      try {

        let res = (await axios.get("/api/logout")).data
        if (res.success) {
          window.localStorage.removeItem('tgs_user');
          window.localStorage.removeItem('access_token');
          commit("SET_USER", {});
          commit("SET_LOGGED_IN", false);
          router.push({ name: "Home" });
        }

        window.flash({ type: res.success ? "success" : "error", msg: res.message })
      } catch (error) {

        return error
      }
    },

    async removeUser({ commit }) {
      try {

        let res = (await axios.get("/api/logout")).data
        if (res.success) {
          window.localStorage.removeItem('tgs_user');
          window.localStorage.removeItem('access_token');
          commit("SET_USER", {});
          commit("SET_LOGGED_IN", false);
          router.push({ name: "Home", params: { lang: "de" } });
        }

        window.flash({ type: "error", msg: "Nutzername und/oder Passwort falsch. Haben Sie ihr Passwort vergessen, klicken Sie auf 'Passwort vergessen?'" })
      } catch (error) {

        return error
      }
    }
  }
};
